import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'section[app-about-believe-section]',
  imports: [MatIconModule],
  templateUrl: './about-believe-section.html',
  styleUrl: './about-believe-section.scss',
})
export class AboutBelieveSection {

}
